<template>
  <div>
  <v-toolbar flat color="white">
    <v-toolbar-title>Alumnos de delegaciones</v-toolbar-title>
    <v-divider
      class="mx-2"
      inset
      vertical
    ></v-divider>
    <v-spacer></v-spacer>
    <v-dialog v-model="dialog" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Alumno independiente</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-flex xs12>
              <v-form ref="form" action="/" v-model="validarInscripcion" lazy-validation>
                <v-text-field label="Colegio" name="colegio_insc" id="colegio_insc" v-model="registro.colegio" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.colegio = registro.colegio.toUpperCase();"/>
                <v-select label="Tipo de colegio" name="tipo_colegio" id="tipo_colegio" :items="tiposColegio" v-model="registro.tipoColegio" v-bind:readonly="disabledRegistro" />
                <v-text-field label="Apellido Paterno" name="apellido_paterno" id="apellido_paterno" v-model="registro.apellidoPaterno" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.apellidoPaterno = registro.apellidoPaterno.toUpperCase();"/>
                <v-text-field label="Apellido materno" name="apellido_materno" id="apellido_materno" v-model="registro.apellidoMaterno" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.apellidoMaterno = registro.apellidoMaterno.toUpperCase();"/>
                <v-text-field label="Nombres" name="nombres" id="nombres" v-model="registro.nombres" :rules="requeridoRegla" v-bind:readonly="disabledRegistro" v-on:keyup="registro.nombres = registro.nombres.toUpperCase();"/>
                <v-text-field label="DNI" name="dni" id="dni" v-model="registro.dni" mask="########" :rules="dniRegla" v-bind:readonly="disabledRegistro"/>
                <v-text-field label="Teléfono" name="telefono" id="telefono" v-model="registro.telefono" mask="#########" :rules="requeridoRegla" v-bind:readonly="disabledRegistro"/>
                <v-text-field label="Correo electrónico" name="correo" id="correo" v-model="registro.correo" v-on:keyup="registro.correo = registro.correo.toUpperCase();" v-bind:readonly="disabledRegistro"/>
                <v-select label="Grado" name="grado" id="grado" :items="grados" v-model="registro.grado" item-text="nombre" item-value="id" :rules="requeridoRegla" return-object required v-bind:readonly="disabledRegistro"/>
                <v-select label="Departamento" name="departamento" id="departamento" v-model="registro.departamento" :items="departamentos" item-text="nombre" item-value="id" :rules="requeridoRegla" return-object required v-bind:readonly="disabledRegistro"/>
                <v-select label="Provincia" name="provincia" id="provincia" v-model="registro.provincia" :items="provincias" item-text="nombre" item-value="id" :rules="requeridoRegla" return-object required v-bind:readonly="disabledRegistro"/>
                <v-select label="Distrito" name="distrito" id="distrito" v-model="registro.distrito" :items="distritos" item-text="nombre" item-value="id" :rules="requeridoRegla" return-object required v-bind:readonly="disabledRegistro"/>
                <v-select label="Sede" name="sede" id="sede" v-model="registro.sede" :items="sedes" item-text="nombre" item-value="id" :rules="requeridoRegla" return-object v-bind:readonly="disabledRegistro"/>
                <v-select v-if="registro.inscripcion !== ''" label="Tipo de inscripción" name="inscripcion" id="inscripcion" :items="tiposInscripcion" v-model="registro.inscripcion" v-bind:readonly="disabledRegistro"/>
                <v-text-field label="Código" name="codigo" id="codigo" v-model="registro.codigo" v-bind:readonly="disabledRegistro"/>
                <v-text-field label="Clave" name="clave" id="clave" v-model="registro.clave" v-bind:readonly="disabledRegistro"/>
              </v-form>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.native="eliminarRegistro" v-if="disabledRegistro && usuarioApp.toUpperCase() === 'ADMINSAN' && !eliminar">Eliminar</v-btn>
          <v-btn color="error" @click.native="eliminarRegistro" v-if="eliminar">Confirmar eliminación</v-btn>
          <v-btn color="primary" v-on:click="disabledRegistro=false" v-if="disabledRegistro && usuarioApp.toUpperCase() === 'ADMINSAN'">Editar</v-btn>
          <v-btn color="primary" @click.native="cerrar">Cerrar</v-btn>
          <v-btn color="primary" @click.native="guardar" v-if="!disabledRegistro">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
  <v-data-table
    :headers="headers"
    :items="datos.data"
    :pagination.sync="pagination"
    :total-items="totalRegistros"
    :loading="loading"
    rows-per-page-text="Filas por página"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.fila[1] }}</td>
      <td>{{ props.item.fila[16] }}</td>
      <td>{{ props.item.fila[2] }}</td>
      <td class="">{{ props.item.fila[3] }}</td>
      <td class="">{{ props.item.fila[4] }}</td>
      <td class="">{{ props.item.fila[5] }}</td>
      <td class="">{{ props.item.fila[6] }}</td>
      <td class="">{{ props.item.fila[7] }}</td>
      <td class="">{{ props.item.fila[9] }}</td>
      <td class="">{{ props.item.fila[10] }}</td>
      <td class="justify-center layout px-0">
        <v-tooltip bottom v-if="props.item.fila[0] !== 0">
          <v-icon
            slot="activator"
            small
            class="mr-2"
            @click="verRegistro(props.item)"
          >open_in_browser</v-icon>
          <span>Ver</span>
        </v-tooltip>
        <v-tooltip bottom v-if="props.item.fila[0] !== 0">
          <v-icon
            v-if="usuarioApp.toUpperCase() === 'ADMINSAN'"
            slot="activator"
            small
            class="mr-2"
            @click="editarRegistro(props.item)"
          >edit</v-icon>
          <span>Editar</span>
        </v-tooltip>
      </td>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
</div>
</template>

<script>
import mixin from '../mixins.js'
import ubicacion from '../ubicacion.js'
export default {
  mixins: [mixin, ubicacion],
  props: ['login', 'tipoUsuario', 'usuarioApp'],
  data: () => ({
    dialog: false,
    disabledRegistro: false,
    validarInscripcion: true,
    eliminar: false,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    menu: false,
    cierreFecha: null,
    tiposColegio: ['ESTATAL', 'PRIVADO'],
    tiposInscripcion: ['VIRTUAL', 'PRESENCIAL'],
    grados: [
      {id: '3A', nombre: 'INICIAL 3 AÑOS'},
      {id: '4A', nombre: 'INICIAL 4 AÑOS'},
      {id: '5A', nombre: 'INICIAL 5 AÑOS'},
      {id: '1P', nombre: '1º PRIMARIA'},
      {id: '2P', nombre: '2º PRIMARIA'},
      {id: '3P', nombre: '3º PRIMARIA'},
      {id: '4P', nombre: '4º PRIMARIA'},
      {id: '5P', nombre: '5º PRIMARIA'},
      {id: '6P', nombre: '6º PRIMARIA'},
      {id: '1S', nombre: '1º SECUNDARIA'},
      {id: '2S', nombre: '2º SECUNDARIA'},
      {id: '3S', nombre: '3º SECUNDARIA'},
      {id: '4S', nombre: '4º SECUNDARIA'},
      {id: '5S', nombre: '5º SECUNDARIA'}
    ],
    sedes: [
      {id: '1', nombre: 'PUNO'},
      {id: '2', nombre: 'JULIACA'},
      {id: '3', nombre: 'ILAVE'}
    ],
    headers: [
      { text: '#', value: 0 },
      { text: 'Código', value: 1 },
      { text: 'Apellido paterno', value: 2 },
      { text: 'Apellido materno', value: 3 },
      { text: 'Nombres', value: 4 },
      { text: 'DNI', value: 5 },
      { text: 'Teléfono', value: 6 },
      { text: 'Correo', value: 7 },
      { text: 'Colegio', value: 8 },
      { text: 'Grado', value: 9 },
      { text: 'Ver', align: 'center', value: '', sortable: false }
    ],
    datos: [],
    registro: {
      colegio: '',
      tipoColegio: '',
      apellidoPaterno: '',
      apellidoMaterno: '',
      nombres: '',
      dni: '',
      telefono: '',
      correo: '',
      grado: '',
      departamento: {id: '', nombre: ''},
      provincia: {id: '', nombre: ''},
      distrito: {id: '', nombre: ''},
      sede: ''
    }
  }),
  computed: {
    provincias () {
      return this.listaProvincias[this.registro.departamento.id]
    },
    distritos () {
      return this.listaDistritos[this.registro.provincia.id]
    }
  },
  watch: {
    dialog (val) {
      val || this.cerrar()
    },
    'registro.cierreFecha' (val) {
      this.cierreFecha = this.formatoFecha(this.registro.cierreFecha)
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
    this.pagination.rowsPerPage = 10
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      }
      solicitudApi.datos = datos
      const myRequest = new Request(`${process.env.API}inicio.php?mod=delegacion&accion=listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            var contar = 1
            for (var indice in datos.d.data) {
              datos.d.data[indice].fila.splice(1, 0, contar)
              contar++
            }
            this.datos = datos.d
            this.totalRegistros = this.datos.registros
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.loading = false
          }
        })
    },
    setTotal: function (total) {
      this.registro.comprobanteTotal = total
    },
    verRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {'id': item.fila[0]}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=delegacion&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d
            this.productosDetalle = {}
            if (item.fila[0] !== 0) {
              this.disabledRegistro = true
            } else {
              this.disabledRegistro = false
            }
            this.dialog = true
          }
        })
    },
    editarRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {'id': item.fila[0]}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=delegacion&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d
            this.disabledRegistro = false
            this.dialog = true
          }
        })
    },
    eliminarRegistro (item) {
      if (!this.eliminar) {
        this.eliminar = true
        return
      }
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {'id': this.registro.id}
      const myRequest = new Request(`${process.env.API}inicio.php?mod=delegacion&accion=eliminar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.disabledRegistro = false
            this.eliminar = false
            this.dialog = false
            let descendente = 0
            if (this.pagination.descending) {
              descendente = 1
            }
            this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
            this.cerrar()
          }
        })
    },
    nuevoRegistro () {
      this.verRegistro({fila: [0]})
    },
    cerrar () {
      this.eliminar = false
      this.dialog = false
      setTimeout(() => {
      }, 300)
    },
    guardar () {
      this.cerrar()
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.API}inicio.php?mod=delegacion&accion=guardar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.verRegistro({fila: [datos.d.id]})
              let descendente = 0
              if (this.pagination.descending) {
                descendente = 1
              }
              this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
            }
          }
        })
    },
    imprimirCredencial (item) {
      this.$router.push('/Credenciales/' + item.fila[0])
      /* var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {datos: [item]}
      const myRequest = new Request(`${process.env.API}credencial.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.blob())
        .then(fileBlob => {
          var newBlob = new Blob([fileBlob], {type: 'application/pdf'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement('a')
          link.href = data
          link.target = '_blank'
          link.click()
        }) */
    },
    informarPago (item) {
      this.$router.push('/Pago/' + item.fila[0])
      /* var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {datos: [item]}
      const myRequest = new Request(`${process.env.API}credencial.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.blob())
        .then(fileBlob => {
          var newBlob = new Blob([fileBlob], {type: 'application/pdf'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement('a')
          link.href = data
          link.target = '_blank'
          link.click()
        }) */
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Delegaciones.vue